const getters = {
    attendance: (state) => state.attendance,
    id: (state) => state.id,
    timerState: (state) => state.timerState,
    loading: state => state.loading
};

export default getters;